import { render, staticRenderFns } from "./PersonalDetailsForm.vue?vue&type=template&id=b33de698&scoped=true"
import script from "./PersonalDetailsForm.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetailsForm.vue?vue&type=style&index=0&id=b33de698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33de698",
  null
  
)

export default component.exports